import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, Divider,
  CircularProgress, LinearProgress
} from "@mui/material";
 import {useLanguageService} from "../services/languageService";
 
 
const columns = [
  //{ id: "LanguageNameId", label: "LanguageNameId" },
  //{ id: "LabelID", label: "LabelID" },
  { id: "LanguageName", label: "Language (English)" },
  { id: "LanguageString", label: "Language" },
  //{ id: "DisplayOrder", label: "Display Order" },
  //{ id: "MessageId", label: "MessageId" },
  { id: "MessageString", label: "Message" },
  { id: "LabelName", label: "Label" },
];

const LanguageInfo = () => {

   const { fetchLanguages } = useLanguageService(); 
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchLanguages()
      .then(setData)
      .catch((err) => setError(err.message || "Failed to fetch data"))
      .finally(() => setLoading(false));
  }, [fetchLanguages]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const filteredData = data.filter((row) =>
    columns.every((col) =>
      !filters[col.id] ||
      String(row[col.id] ?? "")
        .toLowerCase()
        .includes(filters[col.id].toLowerCase())
    )
  );
 
  return (
    <Box sx={{ p: 1, pt:0 }}>
      <Typography variant="h2" gutterBottom>
        Language Settings
      </Typography> 
<Divider sx={{ my: 1 }} />
      {loading ? (
        <LinearProgress />
      ) : error ? (
        <Typography color="error">Error: {error}</Typography>
      ) : (
        <Paper> 
        <TableContainer component={Paper} sx={{ maxHeight: '82vh' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow >
                {columns.map((col) => (
                  <TableCell key={col.id}>
                    <Typography variant="subtitle2">{col.label}</Typography>
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      placeholder="Search"
                      value={filters[col.id] || ""}
                      onChange={(e) => handleFilterChange(col.id, e.target.value)}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, idx) => (
                <TableRow key={idx}>
                  {columns.map((col) => (
                    <TableCell sx={{ py: 0.8, px: 1, fontSize: '0.8125rem' }} key={col.id}>{row[col.id]}</TableCell>
                  ))}
                </TableRow>
              ))}
              {filteredData.length === 0 && (
                <TableRow >
                  <TableCell  colSpan={columns.length} align="center">
                    No matching records.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
         </Paper>
      )}
    </Box>
  );
};

export default LanguageInfo;
